import {useQueryClient, useMutation} from 'react-query'
import {KTSVG, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {deleteMultipleChats} from '../../core/_requests'
import { useCompanies } from '../../../../../auth/core/Companies'

const ChatListGrouping = () => {
  const {selected, clearSelected,setStatusModal} = useListView()
  const queryClient = useQueryClient()
  const {query} = useQueryResponse()
  const {defaultCompany} = useCompanies()

  

  return (
    <div className='d-flex justify-content-end align-items-center'>
      <div className='fw-bolder me-5'>
        <span className='me-2'>{selected.length}</span> Selected
      </div>
      {/* <button
        type='button'
        className='btn btn-primary btn-sm me-2'
        onClick={async () => {
          
        }}
      >        
           <KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-3' />

        Export Selected
      </button> */}
      <button
        type='button'
        className='btn btn-primary btn-sm'
        onClick={async () => {
          setStatusModal(true,true)
        }}
      >        <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />

        

        Delete Selected
      </button>
    </div>
  )
}

export {ChatListGrouping}
